import { render, staticRenderFns } from "./BarberBookingCalendar.vue?vue&type=template&id=b6430a12&scoped=true&"
import script from "./BarberBookingCalendar.vue?vue&type=script&lang=js&"
export * from "./BarberBookingCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BarberBookingCalendar.vue?vue&type=style&index=0&id=b6430a12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6430a12",
  null
  
)

export default component.exports